import React from 'react';
import PropTypes from 'prop-types';
import {
  Botao,
  FacebookIcon,
  AppleIcon,
  InstagramIcon,
  GooglePlayIcon,
  TikTok,
} from './styles';

const Midia = ({ socialMedia, urlSocialNetwork }) => {
  let Icon = null;
  
  switch (socialMedia) {
    case 'facebook':
      Icon = FacebookIcon;
      break;
    case 'instagram':
      Icon = InstagramIcon;
      break;
    case 'apple':
      Icon = AppleIcon;
      break;
    case 'googlePlay':
      Icon = GooglePlayIcon;
      break;
    case 'tiktok':
      Icon = TikTok;
      break;
    default:
      break;
  }

  return (
    <Botao target="_blank" to={urlSocialNetwork}>
      {Icon ? <Icon /> : null}
    </Botao>
  );
};

Midia.propTypes = {
  socialMedia: PropTypes.string,
  link: PropTypes.string,
};

const ButtonSharedSocialNetwork = ({ midias = [], ...props }) => (
  <div {...props}>
    {midias.map((data, key) => (
      <Midia
        key={key}
        socialMedia={data.social_networks}
        urlSocialNetwork={data.link.replace('http:', '')}
      />
    ))}
  </div>
);

ButtonSharedSocialNetwork.propTypes = {
  midias: PropTypes.array,
};

export default ButtonSharedSocialNetwork;
